module.exports = __webpack_public_path__ + "img/placeholder2.eb72edea.jpg";